import type { GameweekWindowEntry } from './types';
import type { TeamFixturePreview } from '@api-service/team-fixtures-preview';
import { GAMEWEEK_ONE, MAX_GAMEWEEK } from '@lib/constants';

/**
 * Walks consecutive gameweeks rather than taking the next N fixtures, so a
 * double gameweek stays in one entry and a blank keeps its place as an empty
 * one. Starts after the current gameweek: mid-round, "next 5" means the ones
 * still to come.
 */
export const buildGameweekWindow = (
  fixtures: TeamFixturePreview[],
  currentGameweek: number,
  count: number
): GameweekWindowEntry[] => {
  const byGameweek = new Map<number, TeamFixturePreview[]>();
  for (const fixture of fixtures) {
    const list = byGameweek.get(fixture.gameweek) ?? [];
    list.push(fixture);
    byGameweek.set(fixture.gameweek, list);
  }

  const start = Math.max(GAMEWEEK_ONE, currentGameweek + 1);
  const window: GameweekWindowEntry[] = [];
  for (
    let gameweek = start;
    gameweek <= MAX_GAMEWEEK && window.length < count;
    gameweek += 1
  ) {
    window.push({ gameweek, fixtures: byGameweek.get(gameweek) ?? [] });
  }
  return window;
};

export const windowEndGameweek = (
  currentGameweek: number,
  count: number
): number => Math.min(MAX_GAMEWEEK, currentGameweek + count);
